import { render, staticRenderFns } from "./VerticalSpace.vue?vue&type=template&id=443b06b6"
import script from "./VerticalSpace.ts?vue&type=script&lang=ts&external"
export * from "./VerticalSpace.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports